<template>
  <div>
    <admin-center-header
      v-if="$can('manage_dermicus') && $route.path.includes('admin')"
      :active-section="1"
      :selected-menu-item="3"
    />
    <center-header v-else selected-menu-item="3" />
    <div class="tab-content space-y-2">
      <div class="clear">
        <button class="btn btn-grey" @click="back">
          <span>{{ trans("general.back") }}</span>
        </button>
      </div>

      <clip-loader v-show="loading" />

      <div v-if="!loading">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">
              {{ trans("center.groupUsersHeadline") }}
            </h3>
          </div>
          <div
            v-if="group.id || $route.path.includes('new')"
            class="panel-body"
          >
            <div class="row">
              <div
                class="form-group m-b-20 col-md-6"
                :class="{ 'has-error': errors.groupName }"
              >
                <label>{{ trans("center.groupUsersGroupNameLabel") }}</label>
                <i class="far fa-asterisk" />
                <input
                  id="title"
                  v-model="group.name"
                  type="text"
                  name="title"
                  class="form-control"
                  data-test="group-name-input"
                  :placeholder="trans('center.groupTableGroupName')"
                />
                <form-error
                  v-if="errors.groupName"
                  :errors="errors.groupName"
                />
              </div>

              <div class="m-b-20 col-md-6">
                <label>{{ trans("center.groupUsersLabel") }}</label>

                <select2
                  class="users select2 form-control responsive"
                  multiple="multiple"
                  data-test="group-members-select"
                  :model-value="group.users"
                >
                  <optgroup :label="trans('forms.chooseUserPlaceholder')">
                    <option
                      v-for="(user, index) in users"
                      :key="index"
                      :value="user.id"
                      data-test="group-admin-user-option"
                      :data-user-id="user.id"
                      :data-user-centre="user.primary_center"
                      :data-user-products="
                        Array.isArray(user.products)
                          ? user.products.join(',')
                          : user.products
                      "
                    >
                      {{ user.name }} ({{ user.primary_center }})
                      {{ user.products }}
                    </option>
                  </optgroup>
                </select2>
              </div>
            </div>

            <span class="text-left"
              ><i class="far fa-asterisk" />
              {{ trans("center.requiredField") }}</span
            >

            <div class="text-right space-x-2">
              <button
                v-if="group.name && group.id"
                class="btn btn-danger"
                data-test="group-delete-btn"
                @click="removeGroup"
              >
                {{ trans("general.formDeleteLabel") }}
              </button>
              <button
                v-if="!loading"
                class="btn btn-primary"
                data-test="group-save-btn"
                :disabled="!isValid || loading"
                :title="
                  isValid ? '' : trans('examination.requiredFieldMissing')
                "
                @click="saveGroupChanges"
              >
                {{ trans("general.formSaveLabel") }}
              </button>
            </div>
          </div>
          <div v-else class="panel-body">
            <div class="text-center">
              {{ trans("chat.groupDeletedMessage") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CenterHeader from "../CenterHeader.vue";
import AdminCenterHeader from "../../Admin/Centers/AdminCenterHeader.vue";
import { getCenterGroupUrlAndComponentPart } from "../../Utils/getCenterGroupUrlAndComponentPart";

export default {
  components: {
    AdminCenterHeader,
    CenterHeader,
  },
  data() {
    return {
      loading: false,
      group: {
        name: "",
        users: "",
        id: "",
      },
      users: [],
      errors: [],
      centerId: null,
      dataUrl: null,
    };
  },
  computed: {
    isValid: function () {
      if (!this.group.name) {
        return false;
      } else {
        return true;
      }
    },
    getCenterGroupUrlAndComponentPart: function () {
      return getCenterGroupUrlAndComponentPart(
        this.$can,
        this.$route,
        this.$store,
      );
    },
  },
  mounted: function () {
    this.dataUrl = this.getCenterGroupUrlAndComponentPart.url;
    this.centerId = this.getCenterGroupUrlAndComponentPart.centerId;
    this.group.id = this.$route.params.groupId;

    this.getGroup();
  },
  methods: {
    getGroup: function () {
      this.loading = true;

      let url;

      if (this.$route.path.includes("new")) {
        url = this.dataUrl + "/new";
      } else {
        url = this.dataUrl + "/" + this.group.id;
      }

      axios
        .get(url)
        .then((data) => {
          let collection = data.data;
          this.group = collection.group;
          this.users = collection.users;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    saveGroupChanges: function () {
      this.loading = true;
      this.errors = [];
      let groupId = this.group.id ? this.group.id : "new";

      let saveUri = this.dataUrl + "/" + groupId;
      axios
        .post(saveUri, {
          groupName: this.group.name,
          resources: $(".users").val(),
        })
        .then((response) => {
          this.$notify({
            text: this.trans("general.notificationSaved"),
            type: "success",
            duration: 1000,
          });

          if (response.data.isNew) {
            this.$router.push({
              name: `${this.getCenterGroupUrlAndComponentPart.adminType}CenterGroups`,
            });
          }

          this.group = response.data.group;
          this.users = response.data.users;

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errors = error.response.data;
          this.userErrorMessage(error);
        });
    },
    removeGroup: function () {
      this.$vueAlert
        .confirm(
          this.trans("general.modalRemoveGroupMessage"),
          undefined,
          undefined,
          {
            confirmButtonText: this.trans("general.modalConfirmButton"),
            cancelButtonText: this.trans("general.modalCancelButton"),
            onOpen: (popup) => {
              popup
                .querySelector(".swal2-confirm")
                ?.setAttribute("data-test", "group-delete-confirm");
              popup
                .querySelector(".swal2-cancel")
                ?.setAttribute("data-test", "group-delete-cancel");
            },
          },
        )
        .then(() => {
          axios.delete(this.dataUrl + "/" + this.group.id).then((response) => {
            this.$notify({
              text: this.trans("general.notificationSaved"),
              type: "success",
              duration: 1000,
            });

            this.$router.push({
              name: `${this.getCenterGroupUrlAndComponentPart.adminType}CenterGroups`,
            });
          });
        })
        .catch((error) => {
          this.userErrorMessage(error);
        });
    },
    back: function () {
      this.$router.go(-1);
    },
  },
};
</script>
